import postgrestRestProvider, { defaultPrimaryKeys, defaultSchema } from "@raphiniert/ra-data-postgrest";
import { addRefreshAuthToDataProvider, type DataProvider } from "react-admin";
import { apiKey, httpClient, refreshAuth, restURL, storageURL } from "./httpClient";
import { fetchActive, fetchAddress,  } from "./http-requests";


const provider = postgrestRestProvider({
        apiUrl: restURL,
        httpClient: httpClient,
        defaultListOp: "eq",
        primaryKeys: defaultPrimaryKeys,
        schema: defaultSchema,
}) as ExtendedDataProvider;

provider.uploadImage = async (file: File) => {
    const hash = await getHash(file);
    const extension = file.name.split(".").pop();
    const url = `${storageURL}/object/images/${hash}.${extension}`;
    const headers: Record<string, string> = {
        apiKey: apiKey,
        "cache-control": "max-age=31536000, immutable",
    };
    const token = localStorage.getItem("access_token");
    if(token) {
        headers.Authorization = `Bearer ${token}`;
    }
    await fetch(url, {
        method: "POST",
        body: file,
        headers,
    }).then(x => x.json());
    return `${hash}.${extension}`;
};

provider.deleteImage = async (path: string) => {
    const url = `${storageURL}/object/images/${path}`;
    const headers: Record<string, string> = {
        apiKey: apiKey,
    };
    const token = localStorage.getItem("access_token");
    if(token) {
        headers.Authorization = `Bearer ${token}`;
    }
    return await fetch(url, {
        method: "DELETE",
        headers
    }).then(x => x.json());
};
const { getList } = provider;

provider.getList = async (resource, params) => {
    if(resource === "shop") {
        return fetchActive(params);
    }
    if(resource === "address") {
        return fetchAddress(params);
    }
    if(resource === "location_address") {
        const [locations, addresses] = await Promise.all([getList("location", params), fetchAddress(params)]);
        return { total: locations.total! + addresses.total!, data: locations.data.concat(addresses.data)};
    }
    return getList(resource, params);
};

export const dataProvider = addRefreshAuthToDataProvider(provider, refreshAuth)

type ExtendedDataProvider = DataProvider & {
    uploadImage: (file: File) => Promise<string | null>;
    deleteImage: (path: string) => Promise<object[] | null>;
};

async function getHash(blob: Blob, algo = "SHA-256"): Promise<string> {
    // convert your Blob to an ArrayBuffer
    // could also use a FileRedaer for this for browsers that don't support Response API
    const buf = await new Response(blob).arrayBuffer();
    const hash = await crypto.subtle.digest(algo, buf);
    let result = "";
    const view = new DataView(hash);
    for (let i = 0; i < hash.byteLength; i += 4) {
        result += toHex(view.getUint32(i));
    }
    return result;
}

export function toHex(num: number): string {
    return num ? num.toString(16).padStart(2, "0") : "000";
}
